import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-premiere-background-image',
  templateUrl: './premiere-background-image.component.html',
  styleUrls: ['./premiere-background-image.component.css']
})
export class PremiereBackgroundImageComponent implements OnInit {

  @Input('premiereDetails') premiereDetails:any;
  eventImage:any
  agilePurchaseEnabled:boolean= environment.agilePurchaseEnabled;
  constructor( private router :Router) { }

  ngOnInit(): void {
    this.eventImage =this.premiereDetails.eventImage
    if(this.eventImage === ""){
    this.eventImage = "assets/images/spotlight/image-not-found.png";
      }
  }
back(){
  // history.back()
  if(this.router.url.includes('archive')){
    this.router.navigate(['cinejoy/premiere/archive']);
  }else{
    this.router.navigate(['cinejoy/premiere/lineup']);
  }
}
  
}
